import { FDealType, getDealType } from './deal_type';
import { FlatType, FOfferType, getOfferType, isFlat, isSuburban } from './offer_type';
import { TOffer } from '../types/offer';

export function getCustomUrl(offer: TOffer) {
  const { dealType, category, offerType } = offer;

  const params: Array<string | undefined | boolean | number> = [];

  const isReliable = offer.newbuilding && offer.newbuilding.showJkReliableFlag;

  if (offer.gaGeo) {
    params.push(offer.gaGeo.moId !== null && `mo_id=${offer.gaGeo.moId}`);
    params.push(offer.gaGeo.oblId !== null && `obl_id=${offer.gaGeo.oblId}`);
    params.push(offer.gaGeo.cityId !== null && `city_id=${offer.gaGeo.cityId}`);
  }

  if (offer.buildingType) {
    params.push(offer.buildingType);
  }

  params.push(dealType);
  params.push(offerType);
  params.push(geTrackingObjectType(dealType, category));
  params.push(getTrackingObjType(offer));
  params.push(getRentType(offer));
  params.push(offer.id);
  params.push(`from_developer=${offer.isFromBuilder ? 1 : 0}`);
  params.push(`repres=${offer.isFromSeller ? 1 : 0}`);
  params.push(`owner=${offer.isByHomeowner ? 1 : 0}`);
  params.push(`pod_snos=${offer.demolishedInMoscowProgramm ? 1 : 0}`);
  params.push(`nv=${isReliable ? 1 : 0}`);

  return `/${params.filter(Boolean).join('/')}/`;
}

function geTrackingObjectType(dealType: string, category: string) {
  if (dealType === 'sale') {
    const offerCategory = category.toLowerCase();

    if (offerCategory.includes('flat') && offerCategory.includes('newbuilding')) {
      return 'object_type=2';
    } else {
      return 'object_type=1';
    }
  }

  return 'object_type=';
}

function getTrackingObjType(offer: TOffer): string | undefined {
  const offerType = getOfferType(offer);

  if (offerType === FOfferType.Bed) {
    return 'ga_obj_type=10';
  }

  if (offerType === FOfferType.Room) {
    return 'ga_obj_type=0';
  }

  if (isFlat(offerType)) {
    if (offer.flatType === FlatType.OpenPlan) {
      return 'ga_obj_type=7';
    }

    if (offer.flatType === FlatType.Studio) {
      return 'ga_obj_type=9';
    }

    if (offer.roomsCount && offer.roomsCount > 0 && offer.roomsCount < 6) {
      return `ga_obj_type=${offer.roomsCount}`;
    }

    if (offer.roomsCount && offer.roomsCount >= 6) {
      return 'ga_obj_type=6';
    }
  }

  if (isSuburban(offerType)) {
    if (offerType === FOfferType.House) {
      return 'ga_obj_type=1';
    }

    if (offerType === FOfferType.HousePart) {
      return 'ga_obj_type=2';
    }

    if (offerType === FOfferType.Land) {
      return 'ga_obj_type=3';
    }

    if (offerType === FOfferType.Townhouse) {
      return 'ga_obj_type=4';
    }
  }

  return undefined;
}

function getRentType(offer: TOffer): string | undefined {
  const dealType = getDealType(offer);

  if (dealType === FDealType.RentDaily) {
    return 'rent_type=daily';
  }

  if (dealType === FDealType.RentLongterm) {
    return 'rent_type=long';
  }

  return undefined;
}

export const getCategory = (offer: TOffer): string => {
  const dealType = getDealType(offer);
  const offerType = getOfferType(offer);

  const mapDealType = {
    [FDealType.RentDaily]: 'rent_day',
    [FDealType.RentLongterm]: 'rent_long',
    [FDealType.Sale]: 'sale',
  };

  let offerTypeStr;
  if (offerType === FOfferType.FlatOld) {
    offerTypeStr = 'flat_old';
  } else if (offerType === FOfferType.FlatNew && Boolean(offer.isFromBuilder)) {
    offerTypeStr = 'flat_new_dev';
  } else if (offerType === FOfferType.FlatNew) {
    offerTypeStr = 'flat_new';
  } else if (offerType & FOfferType.Commercial) {
    offerTypeStr = 'commercial';
  } else if (offerType & FOfferType.Suburban) {
    offerTypeStr = 'suburban';
  } else {
    offerTypeStr = 'flat_old,flat_new';
  }

  return `${mapDealType[dealType]}/${offerTypeStr}`;
};

function getDealTypeSopr(offer: TOffer) {
  const dealType = getDealType(offer);

  const mapDealType = {
    [FDealType.RentDaily]: 'rent_day',
    [FDealType.RentLongterm]: 'rent_long',
    [FDealType.Sale]: 'sale',
  };

  return mapDealType[dealType];
}

export function getProducts(offers: TOffer[]) {
  return offers.map((offer, index) => {
    return {
      category: getCategory(offer),
      cianId: offer.cianId,
      dealType: getDealTypeSopr(offer),
      id: offer.id,
      nv: Boolean(offer.newbuilding && offer.newbuilding.showJkReliableFlag),
      /**
       * objectType вторая часть от category
       */
      objectType: getCategory(offer).split('/')[1],
      owner: Boolean(offer.isByHomeowner),
      photosCount: (offer.photos || []).length,
      podSnos: Boolean(offer.demolishedInMoscowProgramm),
      position: index + 1,
      price: offer.bargainTerms.price,
      /**
       * Всегда 1
       */
      quantity: 1,
      repres: Boolean(offer.isFromSeller),
    };
  });
}
